var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoctor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_971_661)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.1934 35.8066H35.8063V45.9679H24.1934V35.8066Z",
    fill: "url(#paint0_linear_971_661)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1934 41.6123C25.518 43.0228 27.6252 44.0317 29.9998 44.0317C32.3744 44.0317 34.4889 43.0772 35.8063 41.6123V59.9994H24.1934V41.6123Z",
    fill: "url(#paint1_linear_971_661)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1937 41.6123C25.5183 43.0228 27.6255 44.0317 30.0001 44.0317C32.3747 44.0317 34.4892 43.0772 35.8066 41.6123C36.3425 41.7309 37.0066 41.8905 37.7542 42.0841C36.6292 44.3438 33.5868 45.9671 30.0001 45.9671C26.4134 45.9671 23.3711 44.3438 22.2461 42.0841C22.9937 41.8905 23.6578 41.7309 24.1937 41.6123Z",
    fill: "url(#paint2_linear_971_661)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9677 46.9355L7.25806 45.9678C7.25806 45.9678 2.41935 50.8065 0 60H15.9677V46.9355Z",
    fill: "url(#paint3_linear_971_661)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2578 41.1289C18.8078 41.8934 10.1175 43.87 7.25781 45.9676L12.0965 59.9999H28.0643L22.2578 41.1289Z",
    fill: "url(#paint4_linear_971_661)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0322 46.9355L52.7419 45.9678C52.7419 45.9678 57.5806 50.8065 60 60H44.0322V46.9355Z",
    fill: "url(#paint5_linear_971_661)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.742 41.1289C41.192 41.8934 49.8823 43.87 52.742 45.9676L47.9033 59.9999H31.9355L37.742 41.1289Z",
    fill: "url(#paint6_linear_971_661)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4197 24.6082C47.4197 26.7457 45.9028 29.032 44.0326 29.032C42.1624 29.032 40.6455 26.7457 40.6455 24.6082C40.6455 22.4707 42.1624 21.29 44.0326 21.29C45.9028 21.29 47.4197 22.4707 47.4197 24.6082Z",
    fill: "url(#paint7_linear_971_661)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8709 24.6082C18.8709 26.7457 17.3539 29.032 15.4838 29.032C13.6136 29.032 12.0967 26.7457 12.0967 24.6082C12.0967 22.4707 13.6136 21.29 15.4838 21.29C17.3539 21.29 18.8709 22.4707 18.8709 24.6082Z",
    fill: "url(#paint8_linear_971_661)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0968 12.5811H17.9033C16.8206 12.8436 15.9678 13.8863 15.9678 15.0004V24.6815C15.9678 32.9036 22.2581 39.194 30 39.194C37.742 39.194 44.0323 32.9036 44.0323 24.6815V15.0004C44.0323 13.8827 43.1843 12.8411 42.0968 12.5811Z",
    fill: "url(#paint9_linear_971_661)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9999 0C37.5895 0 45.9677 5.89718 45.9677 15C45.9423 20.7641 44.0322 24.6774 44.0322 24.6774C44.0322 21.7742 42.5806 15 42.5806 15C34.3548 16.9355 17.9032 13.0645 17.9032 13.0645C17.9032 13.0645 15.9677 15.9677 15.9677 24.6774C15.9677 24.6774 13.0645 21.2903 13.0645 15.4839C13.0645 8.24274 16.4515 6.77419 16.4515 6.77419C16.4515 6.77419 17.4193 0 29.9999 0Z",
    fill: "url(#paint10_linear_971_661)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.992 35.8065C28.8985 35.8065 27.8073 35.4544 26.8166 34.7504C26.5989 34.5956 26.5481 34.2931 26.7029 34.0754C26.8577 33.8577 27.1602 33.8069 27.3779 33.9617C29.034 35.1387 30.9465 35.1387 32.6267 33.9605C32.8444 33.8069 33.1469 33.8601 33.3005 34.079C33.4541 34.298 33.4009 34.5992 33.1819 34.7528C32.1803 35.4556 31.0844 35.8077 29.992 35.8077V35.8065Z",
    fill: "url(#paint11_linear_971_661)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7104 26.6132C24.5121 26.6132 25.162 25.9633 25.162 25.1616C25.162 24.3599 24.5121 23.71 23.7104 23.71C22.9087 23.71 22.2588 24.3599 22.2588 25.1616C22.2588 25.9633 22.9087 26.6132 23.7104 26.6132Z",
    fill: "url(#paint12_linear_971_661)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2905 26.6132C37.0922 26.6132 37.7421 25.9633 37.7421 25.1616C37.7421 24.3599 37.0922 23.71 36.2905 23.71C35.4888 23.71 34.8389 24.3599 34.8389 25.1616C34.8389 25.9633 35.4888 26.6132 36.2905 26.6132Z",
    fill: "url(#paint13_linear_971_661)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6132 21.288C26.5261 21.288 26.4378 21.2638 26.3579 21.2154C23.6676 19.5413 21.916 20.6675 21.1684 21.1489L21.0668 21.2142C20.8406 21.357 20.5418 21.2892 20.399 21.0642C20.2563 20.838 20.324 20.5392 20.549 20.3965L20.6446 20.336C21.4696 19.805 23.6615 18.3969 26.8696 20.3953C27.097 20.5368 27.166 20.8356 27.0244 21.0618C26.9325 21.2094 26.7753 21.2892 26.6132 21.2892V21.288Z",
    fill: "url(#paint14_linear_971_661)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3871 21.2878C33.225 21.2878 33.0678 21.2068 32.9758 21.0604C32.8343 20.833 32.9033 20.5354 33.1307 20.3939C36.3399 18.3943 38.5307 19.8035 39.3557 20.3346L39.4512 20.3951C39.6774 20.5378 39.744 20.8366 39.6012 21.0628C39.4585 21.289 39.1597 21.3556 38.9335 21.2128L38.8319 21.1475C38.0843 20.666 36.3315 19.5398 33.6412 21.214C33.5613 21.2624 33.4742 21.2866 33.3859 21.2866L33.3871 21.2878Z",
    fill: "url(#paint15_linear_971_661)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9983 31.4513H29.9958C29.5241 31.4513 29.0692 31.2299 28.6797 30.815C28.4971 30.6202 28.5067 30.3142 28.7015 30.1303C28.8963 29.9489 29.2023 29.9573 29.3862 30.1521C29.5277 30.3021 29.7479 30.4823 29.9983 30.4835C30.2499 30.4835 30.4725 30.3033 30.6164 30.1509C30.8003 29.9561 31.1063 29.9477 31.3011 30.1315C31.4946 30.3154 31.5043 30.6214 31.3204 30.8162C30.9273 31.2323 30.4713 31.4525 29.9983 31.4525V31.4513Z",
    fill: "url(#paint16_linear_971_661)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1936 39.6777L28.0646 60.0003L20.3227 52.7423L21.2904 48.8713L17.9033 48.3874L21.7743 41.1293C22.1674 40.4181 23.2864 39.6789 24.1936 39.6777Z",
    fill: "url(#paint17_linear_971_661)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8065 39.6777L31.9355 60.0003L39.6775 52.7423L38.7097 48.8713L42.0968 48.3874L38.2259 41.1293C37.8327 40.4181 36.7138 39.6789 35.8065 39.6777Z",
    fill: "url(#paint18_linear_971_661)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7741 56.6134H19.3548C19.0874 56.6134 18.8709 56.3968 18.8709 56.1295C18.8709 55.8622 19.0874 55.6456 19.3548 55.6456H21.7741C22.3076 55.6456 22.7419 55.2114 22.7419 54.6779V49.8392C22.7419 47.438 20.7882 45.4843 18.387 45.4843C15.9858 45.4843 14.0322 47.438 14.0322 49.8392V54.6779C14.0322 55.2114 14.4665 55.6456 14.9999 55.6456H16.9354C17.2028 55.6456 17.4193 55.8622 17.4193 56.1295C17.4193 56.3968 17.2028 56.6134 16.9354 56.6134H14.9999C13.933 56.6134 13.0645 55.7448 13.0645 54.6779V49.8392C13.0645 46.9045 15.4524 44.5166 18.387 44.5166C21.3217 44.5166 23.7096 46.9045 23.7096 49.8392V54.6779C23.7096 55.7448 22.8411 56.6134 21.7741 56.6134Z",
    fill: "url(#paint19_linear_971_661)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.387 44.5166C15.4524 44.5166 13.0645 46.9045 13.0645 49.8392H14.0322C14.0322 47.438 15.9858 45.4843 18.387 45.4843C20.7882 45.4843 22.7419 47.438 22.7419 49.8392H23.7096C23.7096 46.9045 21.3217 44.5166 18.387 44.5166Z",
    fill: "url(#paint20_linear_971_661)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9355 55.6455H15.9678V56.6132H16.9355C17.2029 56.6132 17.4194 56.3967 17.4194 56.1294C17.4194 55.862 17.2029 55.6455 16.9355 55.6455Z",
    fill: "url(#paint21_linear_971_661)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.355 55.6455H20.3227V56.6132H19.355C19.0876 56.6132 18.8711 56.3967 18.8711 56.1294C18.8711 55.862 19.0876 55.6455 19.355 55.6455Z",
    fill: "url(#paint22_linear_971_661)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7335 36.8398C37.2387 37.1725 36.7222 37.4737 36.1875 37.7423H36.7742C40.5097 37.7423 43.5484 40.781 43.5484 44.5165V50.3229C43.5484 50.5902 43.7649 50.8068 44.0323 50.8068C44.2996 50.8068 44.5161 50.5902 44.5161 50.3229V44.5165C44.5161 40.5729 41.55 37.3152 37.7335 36.8398Z",
    fill: "url(#paint23_linear_971_661)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2969 36.8613C19.8037 37.3017 17.9033 39.4791 17.9033 42.0968V45C17.9033 45.2674 18.1199 45.4839 18.3872 45.4839C18.6545 45.4839 18.8711 45.2674 18.8711 45V42.0968C18.8711 39.6956 20.8247 37.742 23.2259 37.742C23.3541 37.742 23.469 37.69 23.5561 37.6089C23.1231 37.3815 22.7033 37.1323 22.2981 36.8613H22.2969Z",
    fill: "url(#paint24_linear_971_661)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0317 54.6776C45.3678 54.6776 46.451 53.5944 46.451 52.2582C46.451 50.922 45.3678 49.8389 44.0317 49.8389C42.6955 49.8389 41.6123 50.922 41.6123 52.2582C41.6123 53.5944 42.6955 54.6776 44.0317 54.6776Z",
    fill: "url(#paint25_linear_971_661)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0317 54.6776C45.3678 54.6776 46.451 53.5944 46.451 52.2582C46.451 50.922 45.3678 49.8389 44.0317 49.8389C42.6955 49.8389 41.6123 50.922 41.6123 52.2582C41.6123 53.5944 42.6955 54.6776 44.0317 54.6776Z",
    fill: "url(#paint26_linear_971_661)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6123 49.8389H46.451V54.6776H41.6123V49.8389Z",
    fill: "url(#paint27_linear_971_661)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0321 55.1619C42.4305 55.1619 41.1289 53.8603 41.1289 52.2587C41.1289 50.6571 42.4305 49.3555 44.0321 49.3555C45.6337 49.3555 46.9354 50.6571 46.9354 52.2587C46.9354 53.8603 45.6337 55.1619 44.0321 55.1619ZM44.0321 50.3232C42.9652 50.3232 42.0966 51.1918 42.0966 52.2587C42.0966 53.3256 42.9652 54.1942 44.0321 54.1942C45.0991 54.1942 45.9676 53.3256 45.9676 52.2587C45.9676 51.1918 45.0991 50.3232 44.0321 50.3232Z",
    fill: "url(#paint28_linear_971_661)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_971_661",
    x1: 29.9998,
    y1: 44.4341,
    x2: 29.9998,
    y2: 39.3534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6CFBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDAD99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_971_661",
    x1: 29.5934,
    y1: 35.4575,
    x2: 29.4627,
    y2: 30.7155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCF97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAC6A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_971_661",
    x1: 31.0259,
    y1: 24.7833,
    x2: 30.5421,
    y2: 32.9268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCF97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAC6A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_971_661",
    x1: 6.64839,
    y1: 72.8323,
    x2: 8.30323,
    y2: 56.9323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E5E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_971_661",
    x1: 15.7739,
    y1: 69.2321,
    x2: 14.2497,
    y2: 82.3112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E5E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_971_661",
    x1: 53.3528,
    y1: 72.8323,
    x2: 51.698,
    y2: 56.9371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E5E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_971_661",
    x1: 44.2259,
    y1: 69.2321,
    x2: 45.7501,
    y2: 82.3112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E5E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_971_661",
    x1: 44.0326,
    y1: 10.4852,
    x2: 44.0326,
    y2: 34.0352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6CFBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDAD99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_971_661",
    x1: 15.4838,
    y1: 10.4852,
    x2: 15.4838,
    y2: 34.0352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6CFBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDAD99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_971_661",
    x1: 32.3516,
    y1: 8.30847,
    x2: 33.6823,
    y2: 1.41331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6CFBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDAD99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_971_661",
    x1: 29.5161,
    y1: -9.31452,
    x2: 29.5161,
    y2: 30.9435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#957E7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#373638"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_971_661",
    x1: 30.586,
    y1: 25.5677,
    x2: 30.344,
    y2: 29.1968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6CFBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDAD99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_971_661",
    x1: 23.5943,
    y1: 40.8874,
    x2: 23.6523,
    y2: 32.8454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_971_661",
    x1: 36.1695,
    y1: 40.96,
    x2: 36.2324,
    y2: 32.9132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_971_661",
    x1: 23.5164,
    y1: 46.6114,
    x2: 23.5986,
    y2: 35.8888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_971_661",
    x1: 36.0968,
    y1: 46.708,
    x2: 36.1742,
    y2: 35.9806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_971_661",
    x1: 18.8571,
    y1: 32.9174,
    x2: 22.6942,
    y2: 32.1335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6CFBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDAD99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_971_661",
    x1: 28.0114,
    y1: 75.76,
    x2: 27.0533,
    y2: 71.3955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E5E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_971_661",
    x1: 31.99,
    y1: 75.76,
    x2: 32.948,
    y2: 71.3955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E5E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_971_661",
    x1: 19.0983,
    y1: 60.4505,
    x2: 18.9919,
    y2: 59.1827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAAEB1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_971_661",
    x1: 16.7564,
    y1: 36.6247,
    x2: 16.8774,
    y2: 37.5924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_971_661",
    x1: 16.742,
    y1: 56.9374,
    x2: 16.7323,
    y2: 56.831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_971_661",
    x1: 19.5485,
    y1: 56.9374,
    x2: 19.5582,
    y2: 56.831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_971_661",
    x1: 39.4645,
    y1: 33.789,
    x2: 39.5855,
    y2: 34.7568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_971_661",
    x1: 20.0904,
    y1: 36.2081,
    x2: 20.2114,
    y2: 37.1758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_971_661",
    x1: 48.9526,
    y1: 54.005,
    x2: 50.1236,
    y2: 54.4211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C6F73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56585B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_971_661",
    x1: 34.572,
    y1: 51.0002,
    x2: 38.3607,
    y2: 51.5034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_971_661",
    x1: 34.572,
    y1: 51.0002,
    x2: 38.3607,
    y2: 51.5034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C6F73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56585B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_971_661",
    x1: 34.5725,
    y1: 51.0006,
    x2: 38.3612,
    y2: 51.5039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAAEB1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_971_661"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctor);
export default __webpack_public_path__ + "static/media/Doctor.dc1530fb651e76ee038473b70aca69ff.svg";
export { ForwardRef as ReactComponent };